import { type GetHookResponse } from '../hooks'
import { locationAuditKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  type LocationAuditSuccess,
  type LocationAuditInput,
  type LocationPlaceId,
  type LocationAudit,
  isDefined,
} from '@terros/common'

export function useLocationAudit(placeId: LocationPlaceId): GetHookResponse<LocationAudit[]> {
  return useTantalimQuery<LocationAuditInput, LocationAuditSuccess, LocationAudit[]>({
    url: '/location/audit',
    input: { placeId },
    queryKey: locationAuditKey(placeId),
    convertResponse: (data) => data.audit,
    options: {
      enabled: isDefined(placeId),
    },
  })
}
